import { render, staticRenderFns } from "./Specialization.vue?vue&type=template&id=99dc71d2&scoped=true&"
import script from "./Specialization.vue?vue&type=script&lang=js&"
export * from "./Specialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dc71d2",
  null
  
)

export default component.exports